export default __webpack_public_path__ + "static/media/drive-outline-16px.8a73a388.svg";